import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from './Language/LanguageContext';
import './index.css';
import App from './App';
import Routers from './Routers'

ReactDOM.render(
  <LanguageProvider>
    <BrowserRouter>
      <Routers />
    </BrowserRouter>
  </LanguageProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

